import React from "react";

function LEDScreens() {
  return <div>LEDScreens</div>;
}

export default LEDScreens;
